import React, { useState, useEffect, useRef } from "react";
import { useNavigate,useParams } from "react-router-dom";
import { ReactSession } from 'react-client-session';
import Axios from "axios";
import exportValue from "../../apiconfig";
import { requestForToken, onMessageListener } from '../../firebase';
import loader from "./loader.gif";

if (!localStorage.getItem('mojo_firebaseToken')) {
requestForToken().then((data) => {
   console.log("fire token =>> ", data);
   if (data.status && data.token != "") {
     localStorage.setItem('mojo_firebaseToken', data.token);
   }
 });
}

const Login = () => {
  let navigate = useNavigate();
  const { other_id } =useParams();
  ReactSession.setStoreType("localStorage");
	if(localStorage.getItem('user_key')){
            let full_api = exportValue.host + '/' + exportValue.version + '/' + exportValue.api + `/user/loginwithkey`;
            let app_token = localStorage.getItem('user_key');
            let sendData = {app_token:app_token};
            if (localStorage.getItem('mojo_firebaseToken')) {
              sendData.token = localStorage.getItem('mojo_firebaseToken');
            }
            Axios.post(full_api, sendData, { headers: exportValue.headers }).then(res => {
                console.log("login ", res);
                  if(res.data.output.length) {
					  let userDetail = res.data.output[0];
					  ReactSession.set("mojo_loggedIns", JSON.stringify(userDetail));
					  localStorage.setItem('mojo_loggedIn', JSON.stringify(userDetail));
					  
					navigate(`/chat-box/${other_id}`)
        }
                   
      }).catch((e) => {
          // toast.configure()
          // toast.error("Some thing went wrong")
         // console.log("----error:   ", e);
      })
  }else{
    // navigate(`/login`);
    window.location.href=exportValue.loginUrl;
  } 
    return (
        
        <div>
        <section className="vh-100 " style={{backgroundColor: "#e9ecef"}}>
  <div className="container h-100">
    <div className="row d-flex justify-content-center align-items-center h-100">
      <div className="col-lg-12 col-xl-11">
        <div className="text-black" style={{borderRadius: "25px"}}>
          <div className="p-md-5">
            <div className="row justify-content-center">
            <img src={loader} alt="Loading..." style={{width: "6%"}} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
       
    </div>
        )

}

export default Login;